import {CustomerId} from '@shared/services/api/user-entity';
import {GQLPagingParamsVariableStartIndexRequired, GRAPHQL_TYPES} from '@shared/services/api/http-utility-service';

export type TemplateComponentId = number;

export interface TemplateComponentCreateBody {
  name: string;
  description: string | null;
  shared: boolean;
}

export interface TemplateComponent extends TemplateComponentCreateBody {
  component_id: TemplateComponentId;
  customer_id: CustomerId;
}

export const COMPONENTS_OPERATION = 'components';
export const COMPONENT_FIELDS = ['component_id', 'name', 'description', 'shared', 'customer_id'];
export const COMPONENTS_GRAPHQL_QUERY = {
  operation: COMPONENTS_OPERATION,
  fields: COMPONENT_FIELDS,
  variables: {
    ...GQLPagingParamsVariableStartIndexRequired,
    component_id: {type: GRAPHQL_TYPES.INTEGER},
    component_ids: {type: GRAPHQL_TYPES.INTEGER, list: true},
    name: {type: GRAPHQL_TYPES.STRING},
    names: {type: GRAPHQL_TYPES.STRING, list: true},
    shared: {type: GRAPHQL_TYPES.BOOLEAN}
  }
};

export interface TemplateComponentSearchTerm {
  component_id?: TemplateComponentId;
  component_ids?: TemplateComponentId[];
  name?: string;
  names?: string[];
  shared?: boolean;
}
